import { OnInit } from "@angular/core";
var Error500Component = /** @class */ (function () {
    function Error500Component(settings) {
        this.settings = settings;
    }
    Error500Component.prototype.ngOnInit = function () {
    };
    return Error500Component;
}());
export { Error500Component };
